<template>
  <router-view />
</template>

<script setup lang="ts">
// Main App component
</script>

<style>
*, *::before, *::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  background-color: var(--color-surface, #f8fafc);
  font-family: var(--font-sans, 'Inter', -apple-system, sans-serif);
}

#app {
  min-height: 100vh;
}
</style>
